module.exports = __webpack_public_path__ + "fonts/icomoon.3e5d7e5.ttf";